<template>
    <div class="container">
        <b-row class="mb-4 mt-4">
            
        </b-row>
        <b-row>
            <b-col lg="12">
                <h2>Enchant Email Signature Generator</h2>
                <p>Provide your information below to generate you email signature.</p>
            </b-col>
        </b-row>
        <b-row class="justify-content-center-md input-field">
            <b-col lg="4">
                <b-form-input id="emailName"
                    placeholder="Enter your name"
                    v-model="emailName" 
                    max-width="300px">
                </b-form-input>
            </b-col>

        </b-row>
        <b-row class="justify-content-center-md input-field">
            <b-col lg="4">                
                <b-form-input id="title"
                    placeholder="Enter your title"
                    v-model="emailTitle">

                </b-form-input></b-col>

        </b-row>
        <b-row class="justify-content-center-md input-field">
            <b-col lg="4">
                <b-form-input id="phone"
                    placeholder="Enter your work phone"
                    v-model="emailPhone">
                </b-form-input>
            </b-col>

        </b-row>

        <b-row>
            <b-col lg="12" class="margin-top">
                <p>Which signature do you want to generate?</p>
            </b-col>
        </b-row>
        <b-row class="justify-content-center-md mt-3">
            <b-col>
                <b-button  class="submit-btn" @click="renderEnchantHtml">Enchant</b-button>
                <b-button  class="submit-btn" @click="renderLabsHtml">Labs</b-button>
                <b-button  class="submit-btn" @click="renderStudiosHtml">Studios</b-button>
            </b-col>
        </b-row>
        <b-row class="mt-4 mb-4" v-show="showOutput">
            <b-col lg="12">
                <p>Signature:</p>
                <div v-html="htmlOutput">

                </div>
            </b-col>
        </b-row>
        <b-row class="justify-content-center-md margin-top" v-show="showOutput">
            <b-col lg="12"> 
                <h4>Next Steps</h4>
                <ol class="pl-0" style="list-style: decimal inside;">
                    <li>Select, right click and copy your signature above. Make sure you only select the signature area including the logo.</li>
                    <li>Head over to your "Gmail" and go to "Settings" button. Scroll down and find the "Signature" section.</li>
                    <li>Click Create New Signature and paste the generated signature into the text field.</li>
                    <li>Right below the signature text field, you can set this new signature as your default signature.</li>
                    <li>Scroll to the bottom of the Settings page and click "Save".</li>
                </ol>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Mustache from 'mustache';
import enchantTemplate from '../assets/enchant_template';
import labsTemplate from '../assets/labs_template';
import studiosTemplate from '../assets/studios_template';
export default {
    name: "EmailSignature",
    data: function() {
        return {
            emailName: "",
            emailTitle: "",
            emailPhone: "",
            showOutput: false,
            htmlOutput: ""
        }
    },
    methods: {
        renderEnchantHtml() {
            this.showOutput = false; 
            const renderObj = {
                name: this.emailName,
                title: this.emailTitle,
                phone: this.emailPhone
            };

            
            const output = Mustache.render(enchantTemplate, renderObj);
            this.htmlOutput = output;
            this.showOutput = true;
            
        },
        renderLabsHtml() {
            this.showOutput = false; 
            const renderObj = {
                name: this.emailName,
                title: this.emailTitle,
                phone: this.emailPhone
            };

            
            const output = Mustache.render(labsTemplate, renderObj);
            this.htmlOutput = output;
            this.showOutput = true;
            
        },
        renderStudiosHtml() {
            this.showOutput = false; 
            const renderObj = {
                name: this.emailName,
                title: this.emailTitle,
                phone: this.emailPhone
            };

            
            const output = Mustache.render(studiosTemplate, renderObj);
            this.htmlOutput = output;
            this.showOutput = true;
            
        }
    }
}
</script>
<style scoped>
.input-field {
    margin-top: 5px;
}

.submit-btn {
    color: white;
    background-color:black;
    margin: 0 5px 5px 0px;
}

.margin-top {
 margin-top: 30px;   
}
</style>